import React, { useEffect, useMemo, useState, useContext } from "react";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useSelector, useDispatch } from "react-redux";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Typography from "@mui/material/Typography";
import { MenuItem, Grid, Select, CircularProgress } from "@mui/material";
import { SelectionPopupProps } from "@/types/customers";
import MiniLoader from "../MiniLoader";
// import { UserContext } from '@/context/UserContext';
import { use } from "i18next";
import { CustomerSelector } from "./customer-selector";
import { SiteSelector } from "./site-selector";
import { RootState } from "@/store/store";
import { useAppSelector } from "@/store/hooks";
import { User } from "@auth0/auth0-react";
import LocationSelector from "./location-selector";
import { selectSelectedSiteId } from "@/store/selectors";

const SelectionPopup: React.FC<SelectionPopupProps> = ({
  closeCustomerPanel,
  openModal,
  open
}) => {

  const location = useLocation();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [loadingGroups, setLoadingGroups] = useState(false);
  // const { user, loading } = useContext(UserProvider);

  const { data: userData } = useAppSelector((state: RootState) => state.user);
  const users = useSelector(
      (state: RootState) => state.user
  );

  // const userId = userScope?.id;
  // if (!open) {

  // };

  useEffect(() => {
    console.log('User Context in SelectionPopup:',  userData, users);
  }, [userData, users]);

  // Close the popup when the site is changed (not on customer/site-group change)
  const selectedSiteId = useAppSelector(selectSelectedSiteId);
  const isVcmPage = location.pathname.toLowerCase().includes('valve-condition-monitoring');
  const prevSiteId = React.useRef(selectedSiteId);
  useEffect(() => {
    // Only close when a site is actively selected (non-null) and it actually changed
    if (isVcmPage && open && selectedSiteId && prevSiteId.current !== selectedSiteId) {
      closeCustomerPanel();
    }
    prevSiteId.current = selectedSiteId;
  }, [selectedSiteId]);

  // useEffect(() => {
  //   if (!userId || customers?.length > 0 || siteGroups?.length > 0) return;

  //   const fetchGroups = async () => {
  //     setLoadingGroups(true);
  //     try {
  //       const response = await customerClient.get(`/?user_id=${userId}`);
  //       dispatch(setCustomers(response.data.customers));
  //       dispatch(setSiteGroups(response.data.site_groups));
  //     } catch (err) {
  //       console.error(err);
  //     } finally {
  //       setLoadingGroups(false);
  //     }
  //   };

  //   fetchGroups();
  // }, [userId, customers?.length, siteGroups?.length, dispatch]);

  return (
    <Box className={`csgf-root ${open ? 'dblock' : 'dnone'}`}>
      {loadingGroups && (
        <Box className="csgf-loader">
          <MiniLoader size={32} />
        </Box>
      )}

      <Box className="csgf-close">
        <IconButton
          aria-label={t("closePanel", "Close Panel")}
          onClick={closeCustomerPanel}
        >
          <CloseIcon />
        </IconButton>
      </Box>

      <Grid container spacing={2} mt={2}>
        <Grid size={{ xs: 12, sm: 12 }}>
          <Grid container spacing={5}>
            {/* Customer / Site Group Select */}
            <Grid size={{ xs: 12, sm: 4 }}>
              <Typography className="csgf-label">
                {t("customerSiteGroup", "CUSTOMER/SITE GROUP")}
              </Typography>

              <CustomerSelector />
            </Grid>

            {/* SITE */}
            <Grid size={{ xs: 12, sm: 4 }}>
              <SiteSelector />
            </Grid>

            {/* LOCATION */}
            <Grid size={{ xs: 12, sm: 4 }}>
              <LocationSelector />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
};

export default SelectionPopup;